"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const FieldFormatter_1 = require("./FieldFormatter");
const types_1 = require("../types");
class RowFormatter {
  static isRowHashArray(row) {
    if (Array.isArray(row)) {
      return Array.isArray(row[0]) && row[0].length === 2;
    }
    return false;
  }
  static isRowArray(row) {
    return Array.isArray(row) && !this.isRowHashArray(row);
  }
  // get headers from a row item
  static gatherHeaders(row) {
    if (RowFormatter.isRowHashArray(row)) {
      // lets assume a multi-dimesional array with item 0 being the header
      return row.map(it => {
        return it[0];
      });
    }
    if (Array.isArray(row)) {
      return row;
    }
    return Object.keys(row);
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  static createTransform(transformFunction) {
    if ((0, types_1.isSyncTransform)(transformFunction)) {
      return (row, cb) => {
        let transformedRow = null;
        try {
          transformedRow = transformFunction(row);
        } catch (e) {
          return cb(e);
        }
        return cb(null, transformedRow);
      };
    }
    return (row, cb) => {
      transformFunction(row, cb);
    };
  }
  formatterOptions;
  fieldFormatter;
  shouldWriteHeaders;
  _rowTransform;
  headers;
  hasWrittenHeaders;
  rowCount = 0;
  constructor(formatterOptions) {
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;
    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }
    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }
  set rowTransform(transformFunction) {
    if (!(0, lodash_isfunction_1.default)(transformFunction)) {
      throw new TypeError('The transform should be a function');
    }
    this._rowTransform = RowFormatter.createTransform(transformFunction);
  }
  format(row, cb) {
    this.callTransformer(row, (err, transformedRow) => {
      if (err) {
        return cb(err);
      }
      if (!row) {
        return cb(null);
      }
      const rows = [];
      if (transformedRow) {
        const {
          shouldFormatColumns,
          headers
        } = this.checkHeaders(transformedRow);
        if (this.shouldWriteHeaders && headers && !this.hasWrittenHeaders) {
          rows.push(this.formatColumns(headers, true));
          this.hasWrittenHeaders = true;
        }
        if (shouldFormatColumns) {
          const columns = this.gatherColumns(transformedRow);
          rows.push(this.formatColumns(columns, false));
        }
      }
      return cb(null, rows);
    });
  }
  finish(cb) {
    const rows = [];
    // check if we should write headers and we didnt get any rows
    if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
      if (!this.headers) {
        return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
      }
      rows.push(this.formatColumns(this.headers, true));
    }
    if (this.formatterOptions.includeEndRowDelimiter) {
      rows.push(this.formatterOptions.rowDelimiter);
    }
    return cb(null, rows);
  }
  // check if we need to write header return true if we should also write a row
  // could be false if headers is true and the header row(first item) is passed in
  checkHeaders(row) {
    if (this.headers) {
      // either the headers were provided by the user or we have already gathered them.
      return {
        shouldFormatColumns: true,
        headers: this.headers
      };
    }
    const headers = RowFormatter.gatherHeaders(row);
    this.headers = headers;
    this.fieldFormatter.headers = headers;
    if (!this.shouldWriteHeaders) {
      // if we are not supposed to write the headers then
      // always format the columns
      return {
        shouldFormatColumns: true,
        headers: null
      };
    }
    // if the row is equal to headers dont format
    if (Array.isArray(row) && headers.every((header, i) => {
      return header === row[i];
    })) {
      return {
        shouldFormatColumns: false,
        headers
      };
    }
    return {
      shouldFormatColumns: true,
      headers
    };
  }
  // todo change this method to unknown[]
  gatherColumns(row) {
    if (this.headers === null) {
      throw new Error('Headers is currently null');
    }
    if (!Array.isArray(row)) {
      return this.headers.map(header => {
        return row[header];
      });
    }
    if (RowFormatter.isRowHashArray(row)) {
      return this.headers.map((header, i) => {
        const col = row[i];
        if (col) {
          return col[1];
        }
        return '';
      });
    }
    // if its a one dimensional array and headers were not provided
    // then just return the row
    if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
      return row;
    }
    return this.headers.map((header, i) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return row[i];
    });
  }
  callTransformer(row, cb) {
    if (!this._rowTransform) {
      return cb(null, row);
    }
    return this._rowTransform(row, cb);
  }
  formatColumns(columns, isHeadersRow) {
    const formattedCols = columns.map((field, i) => {
      return this.fieldFormatter.format(field, i, isHeadersRow);
    }).join(this.formatterOptions.delimiter);
    const {
      rowCount
    } = this;
    this.rowCount += 1;
    if (rowCount) {
      return [this.formatterOptions.rowDelimiter, formattedCols].join('');
    }
    return formattedCols;
  }
}
exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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